import { BaseApiModel } from '@shared/models/base-api.model';

export class SessionModel extends BaseApiModel {
    token = '';
    expiration = 0;
    refreshToken = '';
    refreshExpiration = 0;
}
